import { differenceInMinutes } from "date-fns";
import { useMemo } from "react";

export default function useIsTimeCorrect(
  start: Date,
  end: Date,
  minDuration = 1
) {
  const timeDifference = useMemo(
    () => differenceInMinutes(end, start),
    [end, start]
  );

  return timeDifference >= minDuration;
}
